export const contextNames = {
  deviceId: 'deviceId',
  fbq: 'fbq',
  genericNetwork: 'genericNetwork',
  gtag: 'gtag',
  image: 'image',
  seo: 'seo',
}
